module.exports = __webpack_public_path__ + "img/banner22.b30bbe91.png";